import resourcesServer from "@/services/config/resourcesServerConfig";

export const saveLead = (data) => {
    return resourcesServer.post("/contact-us/save-lead", data);
}
